import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrManageContentButton } from '@bloomreach/react-sdk';
import { ScrollUpButton } from '@grandvisionhq/common';
import { RelatedLinks } from '@grandvisionhq/content';
import { useAlgoliaConfig, AlgoliaSearch, useAlgoliaData, TealiumProductListingPageView, SearchPageHeader, ConnectedProductListing } from '@grandvisionhq/search';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { useWordLiftRelatedLinks } from '@grandvisionhq/svc-wordlift';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import 'jsonpointer';
import '../../utils/http-client.js';
import { useBloomreachPageModels } from '../../hooks/use-bloomreach-page-models.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachSiteLogos } from '../../hooks/use-bloomreach-site-logos.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { CmsProductCatalogBreadcrumbs } from '../Breadcrumbs/ProductCatalogBreadcrumbs/ProductCatalogBreadcrumbs.js';

function getPromotion({ page , ref  }) {
    const document = ref && page.getContent(ref);
    const content = document === null || document === void 0 ? void 0 : document.getData();
    if (!document) {
        return undefined;
    }
    return swcHelpers.objectSpread({}, content, {
        links: content === null || content === void 0 ? void 0 : content.links[0],
        manageContentButton: /*#__PURE__*/ React.createElement(BrManageContentButton, {
            content: document
        })
    });
}
const CmsProductCatalog = ({ page , content  })=>{
    const { isEnabled  } = useAlgoliaConfig();
    if (!isEnabled) {
        console.error("You're trying to render the <CmsProductCatalog />, but the `AlgoliaConfig` is not configured properly.");
        return null;
    }
    return /*#__PURE__*/ React.createElement(AlgoliaSearch, null, /*#__PURE__*/ React.createElement(CmsProductCatalogContent, {
        page: page,
        content: content
    }));
};
const CmsProductCatalogContent = ({ page , content  })=>{
    var ref, ref1;
    const { total , facetOrder  } = useAlgoliaData();
    const { getLabel  } = useIntl();
    const siteLogos = useBloomreachSiteLogos();
    const { productType  } = useBloomreachPageModels() || {};
    const { title , smallPromotion , bigPromotion  } = content;
    const productPageSelector = (ref = content.productPageSelector) === null || ref === void 0 ? void 0 : ref.filter((item)=>item.url && item.label
    );
    const promotionSmall = getPromotion({
        page,
        ref: smallPromotion
    });
    const promotionBig = getPromotion({
        page,
        ref: bigPromotion
    });
    const { isWordLiftRelatedLinksEnabled  } = useFeatureToggles();
    const { fetchRelatedLinks , relatedLinks , rawResult  } = useWordLiftRelatedLinks();
    React.useEffect(()=>{
        if (isWordLiftRelatedLinksEnabled) {
            fetchRelatedLinks();
        }
    }, [
        fetchRelatedLinks,
        isWordLiftRelatedLinksEnabled
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsProductCatalogBreadcrumbs, {
        title: title
    }), /*#__PURE__*/ React.createElement(TealiumProductListingPageView, {
        productType: productType
    }), /*#__PURE__*/ React.createElement(SearchPageHeader, {
        pageTitle: title,
        hitTitle: `${total} ${getLabel('search.results.amount.title')}`,
        description: (ref1 = content.description) === null || ref1 === void 0 ? void 0 : ref1.value,
        facetOrder: facetOrder,
        productPageSelector: productPageSelector
    }), /*#__PURE__*/ React.createElement(ConnectedProductListing, {
        promotionSmall: promotionSmall,
        promotionBig: promotionBig,
        reimbursableLogos: {
            default: siteLogos.reimbursable,
            alternative: siteLogos.reimbursableAlternative
        }
    }), /*#__PURE__*/ React.createElement(RelatedLinks, {
        rawResult: rawResult,
        relatedLinks: relatedLinks
    }), /*#__PURE__*/ React.createElement(ScrollUpButton, null));
};
var ProductCatalog = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsProductCatalog);

export { CmsProductCatalog, ProductCatalog as default };
//# sourceMappingURL=ProductCatalog.js.map
